import {APP_INITIALIZER, ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter} from '@angular/router';
import {appRoutes} from './app.routes';

import {HttpClientModule} from '@angular/common/http';
import {Apollo} from 'apollo-angular';

import {IconDefinition} from '@ant-design/icons-angular';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {SendOutline, StopOutline, ExportOutline} from '@ant-design/icons-angular/icons';
import {Chat, IconsModule} from '@thx/ui/icons';
import {GraphqlProvidersService} from '@thx/providers/angular';
import {appMocks} from './mocks';
import {environment} from '../environments/environment';
import {convict} from './config/convict-env.config';
import {ChatbotThemes} from "@thx/enums";
import {ChatbotThemeService} from "./services/theme.service";

const icons: IconDefinition[] = [StopOutline, SendOutline, ExportOutline];
const thxIcons: IconDefinition[] = [Chat];

const graphqlProvidersService = new GraphqlProvidersService({
  mocksEnabled: convict.appsyncUseMocks,
  production: environment.production,
  serverUrl: convict.appsyncUrl,
  token: convict.appsyncApiKey,
  authType: convict.appsyncAuthType,
  useRemote: convict.appsyncUseRemote,
  mocks: appMocks,
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    importProvidersFrom(NzIconModule.forRoot(icons),IconsModule.forChild(thxIcons), HttpClientModule),
    Apollo,
    ...graphqlProvidersService.getProviders(),
    {
      provide: APP_INITIALIZER,
      useFactory: (themeService: ChatbotThemeService) => () => {
        const theme = convict?.theme ? (convict.theme as ChatbotThemes) : ChatbotThemes.ETURIA;
        return themeService.loadTheme(theme);
      },
      deps: [ChatbotThemeService],
      multi: true,
    },
  ],
};
